import { DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LabelType } from './data/label-type';
import { Scan } from './data/scan';
import { Store } from '@softline/core';
import { SOFTLINE_FEATURE_SCANNER } from '../application.shared';
import * as ScannerStore from './scanner.store';
import { skip } from 'rxjs';

export interface ScanFnOptions {
  labelTypes?: (LabelType | null | undefined)[];
  match?: RegExp;
}

export function scan(callback: (scan: Scan) => Promise<void>, options?: ScanFnOptions): void {
  const destroyRef = inject(DestroyRef);
  const store = inject(Store);
  store.observe(SOFTLINE_FEATURE_SCANNER, ScannerStore.getters.latest)
    .pipe(
      skip(1),
      takeUntilDestroyed(destroyRef)
    )
    .subscribe(async (scan) => {
      if(!scan)
        return;
      if((options?.labelTypes && !options.labelTypes.includes(scan.labelType))
        || (options?.match && !options.match.test(scan.data)))
        return;
      await callback(scan);
  });
}
